import * as actionTypes from 'constants/ActionTypes';

const user = (state = {
    isLoaded: false,
    isDataFromAutoComplete: false,
    data: [],
}, action) => {
    switch (action.type) {
        case actionTypes.TOGGLE_WHITE_LIST.SUCCESS: {
            const { data } = state;

            data.forEach((user) => {
                if (user._id === action.user._id) {
                    if (user._id === action.user._id) {
                        if (user.limitations) {
                            user.limitations.whiteActive = action.whiteActive;
                        } else {
                            user.limitations = {
                                black: [],
                                white: [],
                                whiteActive: action.whiteActive,
                            }
                        }
                    }
                }
            });


            return {
                ...state,
                data,
            }
        }
        case actionTypes.SET_USER_TO_WHITE_LIST.SUCCESS: {
            const { data } = state;

            data.forEach((user) => {
                if (user._id === action.user._id) {
                    if (user._id === action.user._id) {
                        if (user.limitations) {
                            user.limitations.white = action.emails.map((email) => {
                                return {
                                    email,
                                }
                            });
                        } else {
                            user.limitations = {
                                black: [],
                                white: action.emails.map((email) => {
                                    return {
                                        email,
                                    }
                                }),
                            }
                        }
                    }
                }
            });

            return {
                ...state,
                data,
            };
        }
        case actionTypes.SET_USER_TO_BLACK_LIST.SUCCESS: {
            const { data } = state;

            data.forEach((user) => {
                if (user._id === action.user._id) {
                    if (user.limitations) {
                        user.limitations.black = action.emails.map((email) => {
                            return {
                                email,
                            }
                        });
                    } else {
                        user.limitations = {
                            white: [],
                            black: action.emails.map((email) => {
                                return {
                                    email,
                                }
                            }),
                        }
                    }
                }
            });

            return {
                ...state,
                data,
            };
        }
        case actionTypes.ADD_USERS_FROM_AUTOCOMPLETE:
            return {
                ...action.users,
                isLoaded: true,
                isDataFromAutoComplete: true,
            };
        case actionTypes.GET_USER_LIST.REQUEST:
            return {
                ...state,
                isDataFromAutoComplete: false,
            };
        case actionTypes.GET_USER_LIST.SUCCESS:
            return {
                ...state,
                ...action.data,
                isLoaded: true,
                isDataFromAutoComplete: false,
            };
        case actionTypes.GET_USER_LIST.FAILURE:
            return {
                ...state,
                isLoaded: false,
                isDataFromAutoComplete: false,
            };
        case actionTypes.BAN_USER_BY_ID.REQUEST:
            return {
                ...state,
            };
        case actionTypes.BAN_USER_BY_ID.SUCCESS: {
            const data = state.data.map((item) => {
                if (item._id === action.data._id) {
                    return {
                        ...action.data,
                        banAt: new Date(),
                    }
                }

                return item;
            });

            return {
                ...state,
                data,
            };
        }
        case actionTypes.BAN_USER_BY_ID.FAILURE:
            return {
                ...state,
            };
        case actionTypes.UNBAN_USER_BY_ID.REQUEST:
            return {
                ...state,
            };
        case actionTypes.UNBAN_USER_BY_ID.SUCCESS: {
            const data = state.data.map((item) => {
                if (item._id === action.data._id) {
                    return {
                        ...action.data,
                        banAt: ''
                    }
                }

                return item;
            });

            return {
                ...state,
                data,
            };
        }
        case actionTypes.UNBAN_USER_BY_ID.FAILURE:
            return {
                ...state,
            };
        default:
            return state;
    }
};

export default user;



// WEBPACK FOOTER //
// ./app/reducers/users/index.js